import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

export const RadioButtonGroup = (props) => {
  const {
    radioGroupLabel,
    radioGroupLabelCustomClass,
    radioGroupCustomStyle,
    radioButtonCustomClass,
    onRadioOptionClicked,
    value,
    optionsObject,
    optionsKeysLabels,
    optionPurpose
  } = props;

  // onRadioOptionClicked must set value prop to radio input button id property
  // component provides the selected option key in the options object,
  // optionKeys must be consistent with the keys in the options object

  const [radioOption, setRadioOption] = useState(null);

  useEffect(() => {
    setRadioOption(value);
  }, [value]);

  return (
    <>
      {radioGroupLabel && <label className={radioGroupLabelCustomClass}>{radioGroupLabel}</label>}
      <ul className={radioGroupCustomStyle}>
        {optionsKeysLabels &&
          optionsKeysLabels.map((opt) => {
            const { optionKey, optionLabel } = opt;
            return (
              <li key={optionKey}>
                <span className={radioButtonCustomClass}>
                  <input
                    checked={radioOption === optionsObject[optionKey].key}
                    type="radio"
                    name={optionPurpose}
                    id={optionsObject[optionKey].key}
                    onChange={onRadioOptionClicked}
                  />
                  <label htmlFor={optionKey}>{optionLabel}</label>
                </span>
              </li>
            );
          })}
      </ul>
    </>
  );
};

RadioButtonGroup.propTypes = {
  radioGroupLabel: PropTypes.string,
  radioGroupLabelCustomClass: PropTypes.string,
  radioGroupCustomStyle: PropTypes.string,
  radioButtonCustomClass: PropTypes.string,
  onRadioOptionClicked: PropTypes.func,
  value: PropTypes.string,
  optionsObject: PropTypes.object,
  optionsKeysLabels: PropTypes.array,
  optionPurpose: PropTypes.string
};

export default RadioButtonGroup;
